<div class="modal-content">
  <div class="modal-header bg-primary-100">
    <h5 class="modal-title">Linked Educator(s)</h5>
  </div>
  <form #addAlertForm="ngForm">
    <div class="modal-body">
      <p class="me-3">
        @if (linkedEducatorContext.isPrimaryDuplicateEducator) {
          <span
            >This is the primary educator of a linked grouped and the following EIN(s) have been identified as
            duplicates.</span
          >
        } @else {
          <span>This educator has been identified as a duplicate of one or more EIN(s).</span>
        }
      </p>

      <div>
        <table class="table table-sm table-hover">
          <thead>
            <tr>
              <th scope="col">Type</th>
              <th scope="col">EIN</th>
            </tr>
          </thead>
          <tbody>
            @for (
              duplicatePerson of linkedEducatorContext.duplicateEducators;
              track duplicatePerson.personId;
              let last = $last
            ) {
              <tr>
                <td>
                  <cert-linked-educator-description
                    [isPrimaryEducator]="duplicatePerson.isPrimary"
                  ></cert-linked-educator-description>
                </td>
                <td>
                  <a
                    class="sneaky-link text-body"
                    href="/cert/educators/{{ duplicatePerson.personId }}"
                    target="_blank"
                    >{{ duplicatePerson.personId }}</a
                  >
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
    <div class="modal-footer d-flex">
      <button type="button" class="btn btn-secondary" (click)="onClose()">Close</button>
    </div>
  </form>
</div>
